import { render } from "./HealthAdmin.vue?vue&type=template&id=6aa426ac"
import script from "./HealthAdmin.vue?vue&type=script&lang=js"
export * from "./HealthAdmin.vue?vue&type=script&lang=js"

import "./HealthAdmin.vue?vue&type=style&index=0&id=6aa426ac&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__